import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actions", "count"]
  static values = {
    selectedLabel: { type: String, default: "seleccionados" },
    paramName: { type: String, default: "ids[]" }
  }

  connect() {
    this._frameRenderHandler = () => this.updateUI()
    this.element.addEventListener("turbo:frame-render", this._frameRenderHandler)
    this._openModalHandler = (e) => this._handleOpenModal(e)
    document.addEventListener("batch-select:open-modal", this._openModalHandler)
    this._downloadHandler = (e) => this._handleDownload(e)
    document.addEventListener("batch-select:download", this._downloadHandler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this._frameRenderHandler)
    document.removeEventListener("batch-select:open-modal", this._openModalHandler)
    document.removeEventListener("batch-select:download", this._downloadHandler)
  }

  toggle() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
    this.updateUI()
  }

  _handleOpenModal(event) {
    const ids = this.selectedIds
    if (ids.length === 0) return

    const baseUrl = event.detail.url
    if (!baseUrl) return

    const separator = baseUrl.includes("?") ? "&" : "?"
    const url = `${baseUrl}${separator}${ids.map((id) => `${this.paramNameValue}=${id}`).join("&")}`

    const modalFrame = document.getElementById("modal")
    if (modalFrame) {
      modalFrame.removeAttribute("src")
      modalFrame.src = url
    }
  }

  _handleDownload(event) {
    const ids = this.selectedIds
    if (ids.length === 0) return

    const baseUrl = event.detail.url
    if (!baseUrl) return

    const separator = baseUrl.includes("?") ? "&" : "?"
    const url = `${baseUrl}${separator}${ids.map((id) => `${this.paramNameValue}=${id}`).join("&")}`
    window.location.href = url
  }

  get selectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  updateUI() {
    const ids = this.selectedIds
    const count = ids.length

    if (this.hasActionsTarget) {
      this.actionsTarget.classList.toggle("hidden", count === 0)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${count} ${this.selectedLabelValue}`
    }

    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length
      this.selectAllTarget.checked = count === total && total > 0
      this.selectAllTarget.indeterminate = count > 0 && count < total
    }
  }
}
